/* ============================================================================
   NAYLUNA — LA CINEMATIQUE DU CADEAU, portee sur HORIZON le 2026-10-02
   ----------------------------------------------------------------------------
   Trois exemplaires du patch tombent dans le tiroir, sement une trainee
   d'etoiles et eclatent sur la carte « Le Rituel Nayluna », qui se devoile.

   GENERE PAR `outils/adapter-cine-horizon.py` A PARTIR DE
   `2026-08-theme-nayluna/assets/nayluna-cart-drawer.js`. Ne pas le modifier a
   la main : relancer le script, qui re-applique les adaptations et echoue
   bruyamment si une ancre a disparu.

   DEUX PARTIES DU FICHIER D'ORIGINE SONT VOLONTAIREMENT ABSENTES :
     - l'interception de l'ajout au panier, parce qu'Horizon le fait lui-meme
       depuis que la buy box porte son enveloppe <product-form-component>. La
       reprendre poserait un SECOND intercepteur sur le meme formulaire ;
     - le carrousel d'avis, qui vit dans snippets/nyd-avis-tiroir.liquid.

   CE QUI A ETE ADAPTE DE DAWN A HORIZON :
     <cart-drawer> -> <cart-drawer-component>, .drawer__inner ->
     .cart-drawer__inner, .cart-item__image -> .cart-items__media-image,
     #cart-icon-bubble -> [aria-label="Panier"].

   REGLE DE CONSTRUCTION HERITEE, ET TOUJOURS VRAIE SOUS HORIZON : le theme
   reconstruit tout l'interieur du tiroir a chaque ajout et a chaque
   changement de quantite. Aucun ecouteur pose sur un element du tiroir ne
   survit. Tout passe par de la delegation sur document, et rien ne conserve
   d'etat.
   ========================================================================== */

(function () {
  'use strict';
  /* --- Reglages -------------------------------------------------------- */

  /* Plafond de cinematiques par session. 0 = aucun plafond, elle joue a chaque
     ajout au panier. Il etait a 3 le 18/08, ce qui donnait un comportement
     incomprehensible : elle marchait, puis plus du tout, sans que rien ne
     l'explique a l'ecran. Le remonter seulement si elle finit par lasser. */
  var CINE_MAX_PAR_SESSION = 0;
  var CINE_CHUTE_MS = 900;        /* duree du vol d'une feuille */
  var CINE_DECALAGE_MS = 130;     /* ecart entre les trois feuilles */
  var CINE_PARTICULES_ECLAT = 78; /* par vague, deux vagues */
  var CINE_TAILLE_PX = 34;        /* largeur a l'ecran quand le snippet ne
                                     la donne pas. Il la donne toujours, par
                                     data-nyd-patch-taille : 30 px depuis le
                                     2026-08-26. */

  /* --- Outils ---------------------------------------------------------- */

  function drawer() {
    return document.querySelector('cart-drawer-component');
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --- Les teintes de la pluie d'etincelles ------------------------------

     Elles etaient ecrites en dur, en violet Nayluna : le panier pleuvait
     violet au milieu d'une page Floris verte, exactement le defaut que le
     CSS du tiroir a corrige de son cote par les raccords de la section
     nayluna-palette. Elles viennent desormais des memes tokens : l'or de
     --c-accent, la couleur de marque de --c-atc. La troisieme reste le blanc.

     LA COULEUR DE MARQUE EST REMONTEE EN CLARTE, et c'est le point a ne pas
     retirer. Floris pose --c-atc a #1E5631, un vert foret a 23 % de clarte :
     tel quel il seme des points sombres au lieu d'etincelles. On le remonte a
     55 % en HSL, ce qui laisse sa teinte et sa saturation intactes. Le violet
     Nayluna (#8D54D4) est deja a 58 %, il ressort inchange : la page patchs
     garde sa pluie d'origine. */
  var CINE_OR_REPLI = '244,212,77';       /* --c-accent du socle */
  var CINE_MARQUE_REPLI = '141,84,212';   /* --c-atc du socle */
  var CINE_CLARTE_MIN = 0.55;

  function versRgb(valeur) {
    var h = String(valeur || '').trim();
    if (h.charAt(0) !== '#') return null;
    h = h.slice(1);
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  /* Remonte la clarte HSL sans toucher a la teinte ni a la saturation. Un
     simple melange vers le blanc, lui, desature : #1E5631 y devient un vert
     gris et non un vert menthe. */
  function eclaircit(rgb, clarteMin) {
    var r = rgb[0] / 255, v = rgb[1] / 255, b = rgb[2] / 255;
    var mx = Math.max(r, v, b), mn = Math.min(r, v, b);
    var l = (mx + mn) / 2;
    if (l >= clarteMin) return rgb;

    var d = mx - mn;
    var sat = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    var h = 0;
    if (d !== 0) {
      if (mx === r) h = ((v - b) / d) % 6;
      else if (mx === v) h = (b - r) / d + 2;
      else h = (r - v) / d + 4;
      h *= 60;
      if (h < 0) h += 360;
    }

    l = clarteMin;
    var c = (1 - Math.abs(2 * l - 1)) * sat;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = l - c / 2;
    var t = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0]
          : h < 180 ? [0, c, x] : h < 240 ? [0, x, c]
          : h < 300 ? [x, 0, c] : [c, 0, x];
    return [Math.round((t[0] + m) * 255), Math.round((t[1] + m) * 255), Math.round((t[2] + m) * 255)];
  }

  /* Renvoie 'r,g,b', pret pour rgba(). element sert de point de lecture des
     tokens : ils sont poses sur .nayluna-page, que le tiroir porte. */
  function teinte(element, token, repli, clarteMin) {
    var rgb = null;
    try {
      rgb = versRgb(window.getComputedStyle(element).getPropertyValue(token));
    } catch (e) { /* navigateur trop ancien : on garde le repli */ }
    if (!rgb) return repli;
    if (clarteMin) rgb = eclaircit(rgb, clarteMin);
    return rgb.join(',');
  }

  /* Mode demonstration : ?cine=1 dans l'URL force la cinematique et passe
     outre le reglage systeme. C'est le seul moyen de la voir sur un poste qui
     demande la reduction des animations. */
  /* Le mode reste actif pour toute la session une fois vu dans l'URL : sans
     ca, le moindre rechargement ou la moindre navigation le perd, et la
     cinematique s'arrete sans raison visible. ?cine=0 en sort. */
  function modeDemo() {
    try {
      var p = new URLSearchParams(window.location.search).get('cine');
      if (p === '1') { sessionStorage.setItem('nyd-demo', '1'); return true; }
      if (p === '0') { sessionStorage.removeItem('nyd-demo'); return false; }
      return sessionStorage.getItem('nyd-demo') === '1';
    } catch (e) {
      return false;
    }
  }

  function cineAutorisee() {
    if (modeDemo()) return true;
    if (reduceMotion()) return false;
    if (CINE_MAX_PAR_SESSION <= 0) return true;
    try {
      var n = parseInt(sessionStorage.getItem('nyd-cine') || '0', 10);
      return n < CINE_MAX_PAR_SESSION;
    } catch (e) {
      return true;
    }
  }

  function compteCine() {
    try {
      var n = parseInt(sessionStorage.getItem('nyd-cine') || '0', 10);
      sessionStorage.setItem('nyd-cine', String(n + 1));
    } catch (e) { /* navigation privee : on laisse passer */ }
  }

  /* ==========================================================================
     1. AJOUT AU PANIER SANS RECHARGEMENT
     ========================================================================== */


  function chargeImagePatch(scene) {
    return new Promise(function (resolut) {
      var src = scene.getAttribute('data-nyd-patch') || '';
      if (!src) {
        var vignette = document.querySelector('.cart-items__media-image');
        if (vignette) src = vignette.currentSrc || vignette.src || '';
      }
      if (!src) { resolut(null); return; }

      /* Borne de temps. Sans elle, une image qui ne repond ni par onload ni
         par onerror (socket ouvert, serveur muet) laisse la promesse en
         suspens : la cinematique n'est jamais lancee, et la carte cadeau,
         masquee juste avant, reste invisible sans aucun filet. Au pire on
         part sur la pastille de secours au bout de 1,2 s. */
      var img = new Image();
      var borne = window.setTimeout(function () { resolut(null); }, 1200);
      img.crossOrigin = 'anonymous';
      img.onload = function () { window.clearTimeout(borne); resolut(img); };
      img.onerror = function () { window.clearTimeout(borne); resolut(null); };
      img.src = src;
    });
  }

  function facilite(t) {           /* chute : lente puis rapide */
    return t * t * (3 - 2 * t) * .55 + t * t * .45;
  }

  function lanceCine() {
    var tiroir = drawer();
    if (!tiroir) return;

    var inner = document.querySelector('.cart-drawer__inner');
    var cadeau = tiroir.querySelector('.nyd-gift');
    if (!inner || !cadeau) return;

    /* Sans cinematique, la carte est simplement la. */
    if (!cineAutorisee()) {
      cadeau.classList.remove('is-hidden');
      cadeau.classList.add('is-revealed');
      return;
    }

    compteCine();
    cadeau.classList.add('is-hidden');
    cadeau.classList.remove('is-revealed');

    var scene = document.createElement('div');
    scene.className = 'nyd-cine';
    scene.setAttribute('aria-hidden', 'true');
    var attrPatch = cadeau.getAttribute('data-nyd-patch');
    if (attrPatch) scene.setAttribute('data-nyd-patch', attrPatch);
    inner.appendChild(scene);

    var canvas = document.createElement('canvas');
    scene.appendChild(canvas);

    var boite = inner.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(boite.width * dpr);
    canvas.height = Math.round(boite.height * dpr);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    chargeImagePatch(scene).then(function (image) {
      anime(scene, canvas, ctx, boite, image, cadeau, inner);
    });
  }

  function anime(scene, canvas, ctx, boite, image, cadeau, inner) {
    var L = boite.width;
    var H = boite.height;

    /* Cible : le centre de la carte cadeau, en coordonnees du canvas. */
    var bc = cadeau.getBoundingClientRect();
    var cibleX = bc.left - boite.left + bc.width / 2;
    var cibleY = bc.top - boite.top + bc.height / 2;

    /* Si la carte n'est pas dans la partie visible du tiroir, on vise le
       milieu : la cinematique reste lisible au lieu de tomber hors champ. */
    if (cibleY < 20 || cibleY > H - 20) cibleY = H * .55;

    var reglee = parseFloat(cadeau.getAttribute('data-nyd-patch-taille') || '');
    var TAILLE = reglee > 0 ? reglee : CINE_TAILLE_PX;

    /* LES TRAJECTOIRES. Pas une chute droite : chaque patch suit une courbe
       large, dessinee par une Bezier cubique, et les trois se croisent avant
       de converger sur la carte cadeau. Les amplitudes alternent de signe,
       c'est ce croisement qui donne le mouvement. */
    var AMPLITUDES = [.46, -.40, .30];
    var patchs = [];
    var i;
    for (i = 0; i < 3; i++) {
      var depX = L * (.30 + i * .20);
      var arrX = cibleX + (i - 1) * 14;
      var arrY = cibleY + (i - 1) * 3;
      var amp = L * AMPLITUDES[i];
      patchs.push({
        p0x: depX,
        p0y: -TAILLE,
        c1x: depX + amp,
        c1y: H * .26,
        c2x: arrX - amp * .85,
        c2y: H * .66,
        p3x: arrX,
        p3y: arrY,
        retard: i * CINE_DECALAGE_MS,
        spin: (i - 1) * .9,
        pose: false
      });
    }

    function bezier(p, t) {
      var u = 1 - t;
      var a = u * u * u;
      var b = 3 * u * u * t;
      var c = 3 * u * t * t;
      var d = t * t * t;
      return {
        x: a * p.p0x + b * p.c1x + c * p.c2x + d * p.p3x,
        y: a * p.p0y + b * p.c1y + c * p.c2y + d * p.p3y
      };
    }

    /* Derivee de la Bezier : sert a orienter le patch dans le sens de son
       vol. Il se redresse en approchant de la cible. */
    function pente(p, t) {
      var u = 1 - t;
      var a = 3 * u * u;
      var b = 6 * u * t;
      var c = 3 * t * t;
      return Math.atan2(
        a * (p.c1y - p.p0y) + b * (p.c2y - p.c1y) + c * (p.p3y - p.c2y),
        a * (p.c1x - p.p0x) + b * (p.c2x - p.c1x) + c * (p.p3x - p.c2x)
      ) - Math.PI / 2;
    }

    var particules = [];
    var debut = null;
    var dernier = null;
    var eclatFait = false;
    var deuxiemeVague = false;
    var fini = false;

    function etoile(x, y, r, ctx2) {
      ctx2.beginPath();
      for (var k = 0; k < 8; k++) {
        var rayon = k % 2 === 0 ? r : r * .42;
        var angle = (Math.PI / 4) * k - Math.PI / 2;
        var px = x + Math.cos(angle) * rayon;
        var py = y + Math.sin(angle) * rayon;
        if (k === 0) ctx2.moveTo(px, py); else ctx2.lineTo(px, py);
      }
      ctx2.closePath();
      ctx2.fill();
    }

    /* Lues une seule fois par cinematique : getComputedStyle est un point de
       synchronisation, l'appeler par particule ferait tomber la boucle. */
    var TEINTE_OR = teinte(inner, '--c-accent', CINE_OR_REPLI, 0);
    var TEINTE_MARQUE = teinte(inner, '--c-atc', CINE_MARQUE_REPLI, CINE_CLARTE_MIN);
    /* Les deux bornes du degrade de la pastille de secours, non eclaircies :
       elle est pleine et non semee, une couleur sombre y est lisible. */
    var TEINTE_PASTILLE_A = teinte(inner, '--c-atc', CINE_MARQUE_REPLI, 0);
    var TEINTE_PASTILLE_B = teinte(inner, '--c-text', '104,57,162', 0);

    function couleur(i2) {
      if (i2 % 3 === 0) return TEINTE_OR;      /* or */
      if (i2 % 3 === 1) return TEINTE_MARQUE;  /* couleur de marque */
      return '255,255,255';                    /* blanc */
    }

    function semeTrainee(x, y, i2) {
      particules.push({
        x: x + (Math.random() - .5) * TAILLE * .5,
        y: y + (Math.random() - .5) * TAILLE * .4,
        vx: (Math.random() - .5) * .25,
        vy: (Math.random() - .5) * .25 + .04,
        vie: 0,
        duree: 420 + Math.random() * 320,
        taille: 1 + Math.random() * 2.2,
        rgb: couleur(i2 + Math.floor(Math.random() * 3)),
        etoile: Math.random() < .35
      });
    }

    function eclate(x, y, force) {
      var n = CINE_PARTICULES_ECLAT;
      for (var k = 0; k < n; k++) {
        var angle = (Math.PI * 2 * k) / n + Math.random() * .2;
        var v = (1.4 + Math.random() * 2.6) * force;
        particules.push({
          x: x,
          y: y,
          vx: Math.cos(angle) * v,
          vy: Math.sin(angle) * v,
          vie: 0,
          duree: 620 + Math.random() * 520,
          taille: 1.4 + Math.random() * 2.8,
          rgb: couleur(k),
          etoile: k % 4 === 0,
          gravite: .012
        });
      }
    }

    function dessinePatch(p, x, y, rot, echelle, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(rot);
      ctx.scale(echelle, echelle);

      if (image) {
        var ratio = image.height / image.width || 1;
        ctx.drawImage(image, -TAILLE / 2, -(TAILLE * ratio) / 2, TAILLE, TAILLE * ratio);
      } else {
        /* Sans PNG fourni : une pastille aux couleurs de la page, pour que la
           cinematique reste jouable et testable. Meme raison que la pluie,
           elle etait violette en dur. */
        var d = ctx.createLinearGradient(-TAILLE / 2, -TAILLE / 2, TAILLE / 2, TAILLE / 2);
        d.addColorStop(0, 'rgb(' + TEINTE_PASTILLE_A + ')');
        d.addColorStop(1, 'rgb(' + TEINTE_PASTILLE_B + ')');
        ctx.fillStyle = d;
        ctx.beginPath();
        if (ctx.roundRect) {
          ctx.roundRect(-TAILLE / 2, -TAILLE / 3, TAILLE, TAILLE * .66, TAILLE * .33);
        } else {
          ctx.ellipse(0, 0, TAILLE / 2, TAILLE / 3, 0, 0, Math.PI * 2);
        }
        ctx.fill();
      }
      ctx.restore();
    }

    function boucle(temps) {
      if (fini) return;

      /* Le tiroir s'est ferme ou son contenu a ete reconstruit : on arrete
         proprement au lieu de dessiner dans le vide. */
      if (!scene.isConnected) { termine(); return; }

      if (debut === null) debut = temps;
      var t = temps - debut;

      /* Ecart reel entre deux images, borne : sur un ecran a 120 Hz les
         particules vivraient deux fois trop longtemps si on supposait 60. */
      var dt = dernier === null ? 16.7 : Math.min(50, temps - dernier);
      dernier = temps;
      var k60 = dt / 16.7;

      ctx.clearRect(0, 0, L, H);

      var tousPoses = true;
      for (var k = 0; k < patchs.length; k++) {
        var p = patchs[k];
        var tp = t - p.retard;

        if (tp < 0) { tousPoses = false; continue; }

        var avance = Math.min(1, tp / CINE_CHUTE_MS);
        if (avance < 1) tousPoses = false;

        var e = facilite(avance);
        var pos = bezier(p, e);
        /* Le patch s'oriente dans le sens de son vol, puis se redresse en
           arrivant : un carre qui atterrit de travers se remarque. */
        var inclinaison = pente(p, e) * (1 - e * e) * .55 + p.spin * (1 - e);

        if (avance < 1) {
          semeTrainee(pos.x, pos.y, k);
          dessinePatch(p, pos.x, pos.y, inclinaison, 1, 1);
        } else if (!p.pose) {
          p.pose = true;
        }

        /* Une fois pose, le patch disparait dans l'eclat : on ne le dessine
           plus, il n'y a rien qui traine sur la carte. */
        if (avance >= 1 && tp < CINE_CHUTE_MS + 120) {
          var fondu = 1 - (tp - CINE_CHUTE_MS) / 120;
          dessinePatch(p, p.p3x, p.p3y, 0, 1 + (1 - fondu) * .35, Math.max(0, fondu));
        }
      }

      var finChute = CINE_DECALAGE_MS * 2 + CINE_CHUTE_MS;

      if (!eclatFait && t >= finChute) {
        eclatFait = true;
        eclate(cibleX, cibleY, 1);
        cadeau.classList.remove('is-hidden');
        cadeau.classList.add('is-revealed');
      }

      if (eclatFait && !deuxiemeVague && t >= finChute + 190) {
        deuxiemeVague = true;
        eclate(cibleX, cibleY, .6);
      }

      /* Particules */
      var reste = 0;
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      for (var j = particules.length - 1; j >= 0; j--) {
        var q = particules[j];
        q.vie += dt;
        if (q.vie > q.duree) { particules.splice(j, 1); continue; }
        reste++;

        q.x += q.vx * k60;
        q.y += q.vy * k60;
        if (q.gravite) q.vy += q.gravite * k60;
        q.vx *= Math.pow(.985, k60);
        q.vy *= Math.pow(.985, k60);

        var a = 1 - q.vie / q.duree;
        ctx.fillStyle = 'rgba(' + q.rgb + ',' + (a * .9).toFixed(3) + ')';
        if (q.etoile) {
          etoile(q.x, q.y, q.taille * 1.7 * a, ctx);
        } else {
          ctx.beginPath();
          ctx.arc(q.x, q.y, q.taille * a, 0, Math.PI * 2);
          ctx.fill();
        }
      }
      ctx.restore();

      if (tousPoses && eclatFait && deuxiemeVague && reste === 0) { termine(); return; }
      if (t > 6000) { termine(); return; } /* garde-fou : jamais de boucle infinie */

      window.requestAnimationFrame(boucle);
    }

    function termine() {
      fini = true;
      cadeau.classList.remove('is-hidden');
      cadeau.classList.add('is-revealed');
      if (scene.parentNode) scene.parentNode.removeChild(scene);
    }

    /* Filet de securite. requestAnimationFrame ne tourne pas dans un onglet
       qui n'est pas affiche : sans ce minuteur, la carte cadeau resterait
       masquee tant que l'onglet dort. Mesure faite le 18/08 sur un onglet non
       composite, ou la cinematique restait figee indefiniment. */
    window.setTimeout(function () { if (!fini) termine(); }, 4000);

    window.requestAnimationFrame(boucle);
  }

  /* ==========================================================================
     Mise en place
     ========================================================================== */

  /* --- Declenchement ---------------------------------------------------

     Sous Dawn, la cinematique partait de l'intercepteur d'ajout au panier.
     Ici c'est Horizon qui ajoute, donc on ecoute SON evenement. Le nom a ete
     releve a la mesure sur la page le 2026-10-02 : un ajout emet
     `shopify:cart:lines-update` et rien d'autre qui nous concerne.

     LE DELAI DE 420 ms N'EST PAS UN TATONNEMENT : le tiroir se rouvre avec
     son HTML refait, et `.nyd-gift` n'existe pas encore a l'instant de
     l'evenement. On laisse Horizon reposer son contenu avant de chercher la
     carte. `lanceCine` ressort sans rien faire si elle est absente, donc un
     ajout sur une formule sans guide ne declenche rien.
  --------------------------------------------------------------------- */

  function surMajPanier() {
    window.setTimeout(lanceCine, 420);
  }

  document.addEventListener('shopify:cart:lines-update', surMajPanier);

  /* Mode demonstration : ?cine=1 rejoue la cinematique a l'ouverture du
     tiroir, meme sans ajout au panier. Sous Dawn la poignee etait
     #cart-icon-bubble ; sous Horizon c'est le bouton d'en-tete etiquete
     « Panier ». */
  function initialise() {
    if (!modeDemo()) return;
    var bouton = document.querySelector('[aria-label=\"Panier\"]');
    if (bouton) {
      bouton.addEventListener('click', function () {
        window.setTimeout(lanceCine, 420);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  /* Poignee de console, pour revoir la cinematique a la demande :
     NaylunaCine.play(). `open()` vit sur <theme-drawer id="cart-drawer">
     sous Horizon, pas sur <cart-drawer-component>. */
  window.NaylunaCine = {
    play: function () {
      try { sessionStorage.removeItem('nyd-cine'); } catch (e) {}
      var td = document.getElementById('cart-drawer');
      if (td && typeof td.open === 'function') td.open();
      window.setTimeout(lanceCine, 380);
    }
  };
})();
